import React from 'react';

/**
 * Empty state component to display when there's no content
 *
 * @param {Object} props
 * @param {React.ElementType} props.icon - The icon component to display
 * @param {string} props.title - The title text to display
 * @param {string} props.description - The description text to display
 * @param {React.ReactNode} props.action - Optional action button or link
 */
const EmptyState = ({ icon: Icon, title, description, action = null }) => (
    <div className="bg-white font-[poppins] rounded-xl shadow-md p-8 text-center max-w-lg mx-auto">
        <div className="flex justify-center">
            <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center">
                <Icon className="h-8 w-8 text-gray-400"/>
            </div>
        </div>
        <h3 className="mt-4 text-lg font-medium text-gray-900">{title}</h3>
        <p className="mt-2 text-gray-500 max-w-md mx-auto">
            {description}
        </p>
        {action && (
            <div className="mt-6">
                {action}
            </div>
        )}
    </div>
);

export default EmptyState;